import { inject } from "@angular/core";
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, from, map, mergeMap, of, switchMap } from "rxjs";
import { ImportActions } from "./import.actions";
import { Field } from "../fields/field.model";
import { checkForDuplicates, simplifyFields } from "src/utilities/field-import-helper";
import { FieldActions } from "../fields/fields.actions";
import { ParsedImportFile } from "./import.service";


export const requestLoadFile$ = createEffect(() => {
  return inject(Actions).pipe(
    ofType(ImportActions.loadFiles),
    switchMap((action) => { //usage of switchMap necessary to make sure effect is executed again after reset of loaded fields
      return action.importHandler.loadFields(action.files)
      .pipe(
            mergeMap((parsedFiles: ParsedImportFile[]) => {
              const fileErrors = parsedFiles.filter((parsedFile) => !!parsedFile.errorMessage);

              if (fileErrors.length > 0) {
                return from(
                  fileErrors.map((fileError) =>
                    ImportActions.fileParsingError({
                      filename: fileError.filename,
                      errorMessage: fileError.errorMessage!,
                    })
                  )
                );
              }

              let loadedFields = parsedFiles.flatMap(
                (parsedFile) => parsedFile.fields ?? []
              );

              if (action.simplify) {
                loadedFields = simplifyFields(loadedFields)
              }

              const renamedFields: Field[] = checkForDuplicates(loadedFields, action.existingFields);
              return of(
                ImportActions.fieldsReceived({
                  importedFields: renamedFields.map((f, index) => ({
                    importKey: `${Date.now()}-${index}`,
                    field: f,
                    selected: true,
                    isImported: false,
                    hasError: false,
                  }))
                })
              );
            }),
            catchError(error => {
              const filename = error.filename || 'unknown';
              const errorMessage = error.errorMessage || error.message || error.toString();
              return of(ImportActions.fileParsingError({ filename, errorMessage }));
            })
      )})
    )},
    { functional: true, dispatch: true }
);

export const importFieldCreationFailed$ = createEffect(() => {
    return inject(Actions).pipe(
        ofType(FieldActions.fieldCreationFailed),
        map(({ field, errorMessage }) => {
            console.log("importFieldCreationFailed", field, errorMessage);
            return ImportActions.fieldImportFailed({ field, errorMessage })
        }
        )
    )},
    { functional: true, dispatch: true }
 );
